export interface SplatState {
    background: string;
    objects: {
        ids: Array<number>,
        entities: {}
    };
}

export const initialSplatState: SplatState = {
    background: "",
    objects: {
        ids: [],
        entities: {}
    }
};



// WEBPACK FOOTER //
// ./src/vas/controls/splat/form/lib/splat-state.interface.ts